const Marker = ({ text, friendly_url }) => {

  const handleScroll = (friendly_url) => {

    const locationBox = document.querySelector(`#location-${friendly_url}`);
    locationBox.scrollIntoView( { behavior: 'smooth', block: 'center' } );
    // var scrolledY = window.scrollY;
    // if(scrolledY){
    //   window.scroll(0, scrolledY - 100);
    // }
  }

  return (<div className="marker" onClick={() => handleScroll(friendly_url) }>
  <img src="/find-doctors/images/pin.svg" alt={`${text} marker`} />
  </div>);
};

export default Marker;